import _objectDestructuringEmpty from '/app/node_modules/babel-runtime/helpers/objectDestructuringEmpty';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { NotificationApi } from '../api';

export var state = function state() {
  return {
    notificationCount: 0
  };
};

export var mutations = {
  setNotificationCount: function setNotificationCount(state, notificationCount) {
    state.notificationCount = notificationCount;
  }
};

export var actions = {
  getNotificationsCount: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var commit = _ref.commit;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = commit;
              _context.next = 3;
              return new NotificationApi(this.$axios).getNotificationsCount();

            case 3:
              _context.t1 = _context.sent;
              (0, _context.t0)('setNotificationCount', _context.t1);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getNotificationsCount(_x) {
      return _ref2.apply(this, arguments);
    }

    return getNotificationsCount;
  }(),
  markAsRead: function markAsRead(_ref3, idNotification) {
    _objectDestructuringEmpty(_ref3);

    return new NotificationApi(this.$axios).markNotificationAsRead(idNotification);
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/store/notification.js
// module id = ./src/store/notification.js
// module chunks = 34